import Model, { ID, JsonArray } from 'src/models/Model'

export default class ConfigurationAudit extends Model {
  static name = 'ConfigurationAudit'

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null,
        output: true
      },
      level: {
        type: String,
        default: null,
        output: true
      },
      auditClass: {
        type: String,
        default: null,
        output: true
      },
      messages: {
        type: JsonArray,
        default: () => ([]),
        output: true
      },
      suggestedChanges: {
        type: JsonArray,
        default: () => ([]),
        output: true
      },
      modelType: {
        type: String,
        default: null,
        output: true
      },
      modelId: {
        type: ID,
        default: null,
        output: true
      },
      passed: {
        type: Boolean,
        default: false,
        output: true
      },
      indyOnly: {
        type: Boolean,
        default: false,
        output: true
      },
      suppressed: {
        type: Boolean,
        default: false,
        output: true
      },
      action: {
        type: String,
        input: true,
        default: null
      }
    }

    this.queries = {
      auditByType: {
        arguments: {
          modelType: {
            type: String,
            required: true
          }
        },
        results: {
          configurationAudits: ConfigurationAudit
        }
      }
    }
  }
}
